import React from 'react';
import { CmsBrowsePage } from 'js/model/cms/cms-browse-page';
import { createBrowseAggregations } from 'js/model/view/browse-page/browse-aggregations';
import { BrowsePageMap } from 'js/pages/BrowsePage/MapView/BrowsePageMap';
import { getMapVenues } from 'js/components/LeafletMap/map-utilities';
import { Context } from 'js/components/LocaleWrapper';
import { Channel } from 'js/model/rainbow/content/ChannelOutput';
import { CmsPageTitle } from './BrowseTitle';
import { Hero } from './WhatWhereWhen/Hero';
import { ViewMode } from './ViewModeToggle';
import { ViewProps } from './BrowsePageInner';
import { Category, wwwTrackingContext } from './WhatWhereWhen/tracking';
import styles from './MapView.module.css';
import { changeBrowseDataContext } from './BrowseData';

const collapseActionName = 'map-user-action';

export class MapView extends React.Component<ViewProps> {
  static contextType = Context;

  declare context: React.ContextType<typeof Context>;

  public render(): React.ReactNode {
    const cms = this.context.pageData.cms as CmsBrowsePage & CmsPageTitle;
    const { browsePageOutput, loading, onViewModeChange, onAnySelectFocus } =
      this.props;

    const aggregations = createBrowseAggregations(
      browsePageOutput.aggregations,
      this.context.channel as Channel,
      this.context.pageData.pageParameters
    );

    return (
      <>
        <div className={styles.mapView}>
          <wwwTrackingContext.Provider value={Category.Map}>
            <Hero
              pageData={this.context.pageData}
              cms={cms}
              browsePageOutput={browsePageOutput}
              aggregations={aggregations}
              viewMode={ViewMode.Map}
              collapseOnEvent={collapseActionName}
              onViewModeChange={onViewModeChange}
              onAnySelectFocus={onAnySelectFocus}
            />
          </wwwTrackingContext.Provider>
          <changeBrowseDataContext.Consumer>
            {(changeBrowseData) => (
              <BrowsePageMap
                venues={getMapVenues(browsePageOutput)}
                changeBrowseData={changeBrowseData}
                location={browsePageOutput.specification.location}
                cms={cms}
                channel={this.context.channel}
                mapView="mobile"
                loading={loading}
              />
            )}
          </changeBrowseDataContext.Consumer>
        </div>
      </>
    );
  }
}

MapView.contextType = Context;
